import * as React from 'react';
import styles from './index.less';
import { Drawer } from 'antd';
import type { DrawerProps } from 'antd';
import FComponentsLib from '@freelog/components-lib';
import FIcons from '@/components/FIcons';
import FSimpleBar from '../FSimpleBar';

interface FDrawerProps extends DrawerProps {
  children: React.ReactNode | React.ReactNodeArray;
  title: string | React.ReactNode;
  topRight?: React.ReactNode;
  loading?: boolean | string;
  contentStyle?: React.CSSProperties;
  drawerBodyStyle?: React.CSSProperties;
}

function FDrawer({
  children,
  topRight,
  width = 720,
  title,
  onClose,
  loading = false,
  contentStyle = {},
  drawerBodyStyle = {},
  headerStyle: _headerStyle,
  bodyStyle: _bodyStyle,
  styles: customStyles,
  ...props
}: FDrawerProps) {
  return (
    <Drawer
      className={styles.style}
      title={null}
      styles={{
        ...customStyles,
        header: { display: 'none' },
        body: { padding: 0 },
      }}
      width={width}
      onClose={onClose}
      maskClosable={false}
      {...props}
    >
      <div
        className={styles.drawerBody}
        style={{
          // width: Number.parseInt(String(width)) - 17,
          ...drawerBodyStyle,
        }}
      >
        <div className={styles.header} style={{ width: width }}>
          {typeof title === 'string' ? (
            <FComponentsLib.FTitleText type="h2" text={title} />
          ) : (
            title
          )}
          {topRight || (
            <FComponentsLib.FTextBtn
              type="default"
              onClick={(e: any) => onClose && onClose(e)}
            >
              <FIcons.FClose />
            </FComponentsLib.FTextBtn>
          )}
        </div>
        {/*<div style={{ height: 70 }} />*/}
        <FSimpleBar height={'calc(100vh - 70px)'}>
          <div className={styles.content} style={contentStyle}>
            {children}
          </div>
        </FSimpleBar>

        {!!loading && (
          <div className={styles.loading}>
            <FIcons.FLoading style={{ fontSize: 16 }} />
            {loading !== true && <span>{loading}</span>}
          </div>
        )}
      </div>
    </Drawer>
  );
}

export default FDrawer;
